export default __webpack_public_path__ + "static/media/reception.57626197.svg";